// removed by extract-text-webpack-plugin
module.exports = {"Loader":"Loader__Loader__3ebYO","LogoHolder":"Loader__LogoHolder__1C3dN","Logo":"Loader__Logo__2_z7V","logoSwing":"Loader__logoSwing__TLEsw"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Loader/Loader.css
// module id = 56
// module chunks = 0